module.exports = __webpack_public_path__ + "img/scratch.eb111387.jpg";